import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import {catchError} from "rxjs/operators";
import {HandleErrorService} from "../handleError.service";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DataFileService extends HandleErrorService {
  checkPmaj(dealershipId: number): Observable<any> {
    const apiUrl = environment.globalApiUrl + 'api/pmaj/check/' + dealershipId;
    return this.http.get<any>(apiUrl, environment.httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  uploadPmaj(productId: number, file: File ): Observable<any> {
    const formData = new FormData();
    formData.append('job', file, file.name);
    const apiUrl = environment.globalApiUrl + 'api/pmaj/upload/' + productId;
    return this.http.post<any>(apiUrl, formData, environment.httpOptionSimple).pipe(
      catchError(this.handleError)
    );
  }
  downloadPmaj(productId: number): Observable<any> {
    const apiUrl = environment.globalApiUrl + 'api/pmaj/download/' + productId;
    return this.http.get<any>(apiUrl, {
      // @ts-ignore
      responseType: 'blob',
      headers: { Authorization : 'Bearer ' + sessionStorage.getItem('token') }
    }).pipe(
      catchError(this.handleError)
    );
  }
  deletePmaj(jobId): Observable<any> {
    const apiUrl = environment.globalApiUrl + 'api/pmaj/delete/' + jobId;
    return this.http.delete<any>(apiUrl, environment.httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  getCertificateInfos(): Observable<any> {
    const apiUrl = environment.globalApiUrl + 'api/pmaj/certificate/infos';
    return this.http.get<any>(apiUrl, environment.httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  uploadCertificate(file: any ): Observable<any> {
    const formData = new FormData();
    formData.append('certificate', file, file.name);
    const apiUrl = environment.globalApiUrl + 'api/pmaj/certificate/upload';
    return this.http.post<any>(apiUrl, formData, environment.httpOptionSimple).pipe(
      catchError(this.handleError)
    );
  }
  downloadCertificate(): Observable<any> {
    const apiUrl = environment.globalApiUrl + 'api/pmaj/certificate/download/name';
    return this.http.get<any>(apiUrl, {
      // @ts-ignore
      responseType: 'blob',
      headers: { Authorization : 'Bearer ' + sessionStorage.getItem('token') }
    }).pipe(
      catchError(this.handleError)
    );
  }
  downloadCertificateById(certificateId): Observable<any> {
    const apiUrl = environment.globalApiUrl + 'api/pmaj/certificate/download/id/' + certificateId;
    return this.http.get<any>(apiUrl, environment.httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  getFilesInfos(): Observable<any> {
    const apiUrl = environment.globalApiUrl + 'api/pmaj/files/infos';
    return this.http.get<any>(apiUrl, environment.httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  deleteCertificate(certificateId): Observable<any> {
    const apiUrl = environment.globalApiUrl + 'api/pmaj/certificate/delete/' + certificateId;
    return this.http.delete<any>(apiUrl, environment.httpOptions).pipe(
      catchError(this.handleError)
    );
  }
}
